import { render, staticRenderFns } from "./CtaCardTwo.vue?vue&type=template&id=172005ba"
import script from "./CtaCardTwo.vue?vue&type=script&lang=js"
export * from "./CtaCardTwo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports